/* eslint-disable */
export default {
  title: 'Audio',
  dialButtonVolume: 'Volume du bouton de composition',
  ringtoneVolume: 'Volume de sonnerie',
  callVolume: 'Volume d’appel',
  muteCalls: 'Activer le mode muet pour les appels',
  outputDevice: 'Périphérique de sortie',
  inputDevice: 'Périphérique d’entrée',
  micPermission: 'Autorisation microphone',
  noDevice: 'Aucun terminal',
  checkMicPermission: 'Vérifier l’autorisation',
  micNoPermissionMessage:
    'L’application n’est pas autorisée à utiliser le microphone',
  noLabel: 'Périphérique inconnu',
  notSetSinkIdTip:
    'Désolé, vos autorisations de navigateur actuelles ne sont pas définies pour nous permettre d’accéder à vos périphériques de sortie audio. {clickHereLink} pour modifier les paramètres.',
  noLabelTip:
    'Désolé, vos autorisations de navigateur actuelles ne sont pas définies pour nous permettre d’accéder à vos périphériques d’entrée audio.',
  clickHere: 'Cliquez ici',
  defaultOutputDevice: 'Périphérique de sortie par défaut',
} as const;

// @key: @#@"title"@#@ @source: @#@"Audio"@#@
// @key: @#@"dialButtonVolume"@#@ @source: @#@"Dial Button Volume"@#@
// @key: @#@"ringtoneVolume"@#@ @source: @#@"Ringtone Volume"@#@
// @key: @#@"callVolume"@#@ @source: @#@"Call Volume"@#@
// @key: @#@"muteCalls"@#@ @source: @#@"Mute Calls"@#@
// @key: @#@"outputDevice"@#@ @source: @#@"Output Device"@#@
// @key: @#@"inputDevice"@#@ @source: @#@"Input Device"@#@
// @key: @#@"micPermission"@#@ @source: @#@"Microphone Permission"@#@
// @key: @#@"noDevice"@#@ @source: @#@"No device"@#@
// @key: @#@"checkMicPermission"@#@ @source: @#@"Check Permission"@#@
// @key: @#@"micNoPermissionMessage"@#@ @source: @#@"The app does not have permission to use microphone"@#@
// @key: @#@"noLabel"@#@ @source: @#@"Unknown device"@#@
// @key: @#@"notSetSinkIdTip"@#@ @source: @#@"Sorry, your current browser permissions aren't set to allow us to access your audio output devices. {clickHereLink} to see how to set up."@#@
// @key: @#@"noLabelTip"@#@ @source: @#@"Sorry, your current browser permissions aren't set to allow us to access your audio input devices."@#@
// @key: @#@"clickHere"@#@ @source: @#@"Click here"@#@
// @key: @#@"defaultOutputDevice"@#@ @source: @#@"Default output device"@#@
